/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ZerogAddressTokenPortfolioListRequest = {
    page?: number;
    size?: number;
    address: string;
    sortField?: ZerogAddressTokenPortfolioListRequest.sortField;
    sortDirection?: ZerogAddressTokenPortfolioListRequest.sortDirection;
};

export namespace ZerogAddressTokenPortfolioListRequest {

    export enum sortField {
        VALUE = 'VALUE',
        BALANCE = 'BALANCE',
        NAME = 'NAME',
    }

    export enum sortDirection {
        ASC = 'ASC',
        DESC = 'DESC',
    }


}

